import type { Report } from '../redux/reducers/reports'
import { getRole } from './getRole'

/**
 * В разделе «Путевые» для водителя:
 * — «Закрыт» не показываем;
 * — «Отправлен» — только свои (user.id === текущий пользователь);
 * — «Черновик» и «В рейсе» — все.
 */
export function filterReportsForDriverVisibility(reports: Report[]): Report[] {
  const { isDriver, userId } = getRole()
  if (!isDriver || !Array.isArray(reports)) return reports

  return reports.filter((r) => {
    if (r.status === 'closed') return false
    if (r.status === 'sent') {
      if (userId == null) return false
      return Number(r.user?.id) === Number(userId)
    }
    return true
  })
}
